import { ReactNode, useMemo } from 'react';
import { Text, TextProps } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Checkbox } from '@connect-x-app/web-ui';
import { CellContext } from '@tanstack/react-table';

import { FlexComponent } from '..';

type TableCellProps<T, U> = {
  formatter?: (value: U) => ReactNode;
  textProps?: Partial<TextProps>;
  withCheckbox?: boolean;
} & CellContext<T, U>;

export const TableCell = <T, U>({ formatter, getValue, row, textProps, withCheckbox = false }: TableCellProps<T, U>) => {
  const rawValue = getValue();
  const value = formatter ? formatter(rawValue) : rawValue;

  const displayValue = useMemo(() => {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    if (value === undefined || value === null) {
      return '';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  }, [value]);

  return (
    <FlexComponent flexDirection="row">
      {withCheckbox ? (
        <Checkbox
          checked={row.getIsSelected()}
          data-test={ADMIN_TEST_IDS.shared.selectCheckbox}
          name="table-cell"
          onChange={val => row.toggleSelected(val)}
        />
      ) : null}
      <Text as="span" color={COLORS.zulu.$06} size="MD" width="partial-width" {...textProps}>
        {displayValue}
      </Text>
    </FlexComponent>
  );
};
